import timeFormAPI from '../../api/ui/timeFormAPI';
import {create} from './table-schema';
import useTranslation from '../../hooks/useTranslation';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {convertFalsyToHyphen} from "../../constants/base";

function useSchemaMonitoringUser() {
    const {t} = useTranslation();
    const locale = useSelector((state) => state.language.locale);

    /**
     * 테이블 헤더에 표시할 항목 문자열 배열
     */
    const headerKeys = [
        "날짜",
        "총 회원",
        "이용정지 회원",
        "신규 회원",
        "로그인 회원",
        "활성 회원",
        "총 홀더",
        "이용 정지 홀더",
        "로그인 홀더",
        "액티브 홀더",
        "홀더 전환",
        "비홀더 전환",
        "최초 홀더 전환"
    ];

    /**
     * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
     *
     * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
     *
     * param1은 헤더의 첫번째 표시되는 항목이다.
     *
     * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
     *
     * key는 반드시 있어야 한다.
     * @param {object} row
     * @returns
     */
    const parse = (row) => {

        const id = row?.index;
        const date = timeFormAPI.changeDataDate(row?.targetDate);
        const totalAccountCount = row?.totalAccountCount || 0;
        const suspendedAccountCount = row?.suspendedAccountCount || 0;
        const newAccountCount = row?.newAccountCount || 0;
        const signInAccountCount = row?.signInAccountCount || 0;
        const activatedAccountCount = row?.activatedAccountCount || 0;
        const totalHolderCount = row?.totalHolderCount || 0;
        const suspendedHolderCount = row?.suspendedHolderCount || 0;
        const signInHolderCount = row?.signInHolderCount || 0;
        const activatedHolderCount = row?.activatedHolderCount || 0;
        const convertedHolderCount = row?.convertedHolderCount || 0;
        const convertedNonHolderCount = row?.convertedNonHolderCount || 0;
        const convertedFirstHolderCount = row?.convertedFirstHolderCount || 0;

        return {
            key: id, // 키는 반드시 있어야 한다.
            param1: date,
            param2: convertFalsyToHyphen(totalAccountCount.toLocaleString()),
            param3: convertFalsyToHyphen(suspendedAccountCount.toLocaleString()),
            param4: convertFalsyToHyphen(newAccountCount.toLocaleString()),
            param5: convertFalsyToHyphen(signInAccountCount.toLocaleString()),
            param6: convertFalsyToHyphen(activatedAccountCount.toLocaleString()),
            param7: convertFalsyToHyphen(totalHolderCount.toLocaleString()),
            param8: convertFalsyToHyphen(suspendedHolderCount.toLocaleString()),
            param9: convertFalsyToHyphen(signInHolderCount.toLocaleString()),
            param10: convertFalsyToHyphen(activatedHolderCount.toLocaleString()),
            param11: convertFalsyToHyphen(convertedHolderCount.toLocaleString()),
            param12: convertFalsyToHyphen(convertedNonHolderCount.toLocaleString()),
            param13: convertFalsyToHyphen(convertedFirstHolderCount.toLocaleString()),
        };
    };

    /**
     * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
     *
     * 입력값인 row는 위의 parse에서 변환된 값이다.
     *
     * @param {object} row
     * @returns
     */
    const details = (row) => {
        const array = [];
        if (row) {
            //
        }
        return array;
    };

    const [schema, setSchema] = useState();

    useEffect(() => {
        const headers = headerKeys.map((key) => t(key));
        const schema = create({
            heads: headers,
            parseFunc: parse,
            detailFunc: details,
        });
        setSchema(schema);
    }, [locale]);

    return schema;
}

export default useSchemaMonitoringUser;
